import {useState} from 'react'

const MOBILE_WIDTH = 576
const extendConditionInputs = false
const MAX_CONDITIONS_LENGTH = 10

export const useFocusBlur = () => {
    const [focusedInput, setFocusedInput] = useState(null)

    const handleFocus = (name, index) => {
        if (window.innerWidth > MOBILE_WIDTH && extendConditionInputs) {
            setFocusedInput({[index]: name})
        }
    }

    const handleBlur = () => {
        if (window.innerWidth > MOBILE_WIDTH && extendConditionInputs) {
            setFocusedInput(null)
        }
    }

    return {
        focusedInput,
        handleFocus,
        handleBlur
    }
}

export const useConditionManagement = (formikRef) => {
    const [submitted, setSubmitted] = useState([])

    const handleConditionsInputChange = (index, field, value, isJsonType = false) => {
        const {values, setValues} = formikRef.current
        const type = values?.conditionOption?.type
        const updatedConditions = Array.isArray(values.conditions[type])
            ? [...values.conditions[type]]
            : []

        if (updatedConditions?.length === 0) {
            return
        }

        updatedConditions[index][field] = value

        if (
            index === updatedConditions.length - 1 &&
            isJsonType &&
            updatedConditions.length < MAX_CONDITIONS_LENGTH
        ) {
            updatedConditions.push({
                key: '',
                operator: Object.values(values.conditionOption.values)[0],
                value: ''
            })
        }

        setValues({
            ...values,
            conditions: {...values.conditions, [type]: updatedConditions}
        })
    }

    const handleRemoveConditions = (condition, conditionIndex, index, errors) => {
        const {values, setValues, setErrors} = formikRef.current
        const type = values?.conditionOption?.type
        const conditions = values?.conditions?.[type]

        const updatedConditions = conditions.filter((_, i) => index !== i)
        const updatedSubmitted = submitted?.filter((_, i) => index !== i)

        setSubmitted(updatedSubmitted)
        setValues({
            ...values,
            conditions: {
                ...values.conditions,
                [type]: updatedConditions
            }
        })

        let updatedErrors = {...errors}

        if (updatedErrors[condition.key]) {
            updatedErrors[condition.key] = updatedErrors[condition.key].filter((_, idx) => idx !== conditionIndex)

            if (updatedErrors[condition.key]?.length === 0) {
                updatedErrors[condition.key] = null
            }
        }

        setErrors(updatedErrors)
    }

    const keyCounts = Array.isArray(submitted) ? submitted?.reduce((obj, item) => {
        if (item.key) {
            obj[item.key] = (obj[item.key] || 0) + 1
        }
        return obj
    }, {}) : null

    return {
        handleConditionsInputChange,
        handleRemoveConditions,
        submitted,
        setSubmitted,
        keyCounts
    }
}
